import React from 'react'
import { Container, Col, Row, Form, Button} from 'react-bootstrap'
import questionsAll from '../Helpers/QuestionDB'
import {getContactsList, createContact} from '../Helpers/sib';
import { withRouter } from 'react-router-dom'
import '../App.css'
import logo from "../assets/logo-vinidaily-white.png"
import profiles_desc from '../Helpers/profileDescription'
import vigne from '../assets/feuille-vigne-314x261.svg'
import grappe from '../assets/grappe-171x365.svg'
import barrique from '../assets/barrique-243x279.svg'
import gif from '../assets/WNRA.gif'
import firebase from '../Helpers/firebase'
import TimeLeft from '../Helpers/timer'

class GiftQuestionProfile extends React.Component {  
    constructor(){
        super();

        this.state = {
            questionsAll : questionsAll,
            CheckBox : this.checkBoxInit(),
            form_complete : false,
            firstname: "",
            lastname: "",
            email: "",
            phone: "",
            postcode: "",
            street: "",
            city: "",
            number:"",
            showForm: true,
            showEmail:false,
            newsletter: false,
            pcAgreement:false,
            rgpdOk: false,
            mailAlreadySend:false,
            modifying:false,
            modifyingAdress:false,
            modifyingProfil: false,
            timeStatusOk: false,
            firstConnection: true
        }
    }

    componentDidMount(){
        this.refreshDB()
        this.setState({
            email: this.props.email,
            showEmail: this.props.showEmail,
            orderId: this.props.id
            })
    
    }

    async getMails(){
        const orders = await firebase.firestore().collection('ordersTreated').get()
        console.log(orders)
        return orders
    }
    
    refreshDB(){
        var pushTime = ""
        this.getMails().then(
            orders => {
            orders.forEach(m =>{
                console.log(m)
                if (m.data().id === this.props.id){
                    console.log(pushTime)
                    pushTime = pushTime ? (new Date(m.data().date.seconds *1000) < pushTime ? new Date(m.data().date.seconds*1000) : pushTime) : new Date(m.data().date.seconds*1000)
                    console.log(pushTime)
                    this.setState({
                        mailAlreadySend: true,
                        firstConnection: false
                        })
                }
            })
            if (pushTime===""){
                this.setStateSync({
                    pushTime: new Date(),
                    timeStatusOk: true
                })
            }
            else{
                this.setState({
                    pushTime: pushTime})
            }

            if (new Date()-pushTime < 172800000){
            this.setState({
                timeStatusOk: true})
            }
        })
    }

    setStateSync(state){
        return new Promise(resolve=>{
            this.setState(state,resolve)
        })
    }

    checkBoxInit(){
        var CheckBoxResults = []
        questionsAll.forEach((question) => {
            if (question.type === "user_profil"){
                question.answers.forEach((answer) => {
                        CheckBoxResults = CheckBoxResults.concat({id: answer.id, value: false, score: answer.score})
                })
            }
        })
        return CheckBoxResults
    }
    isFormComplete(){
        var state = []
        for (let i=1; i<5;i++){
            state = this.state.CheckBox.filter((obj) => (obj.value === true) && (~~(obj.id/10)===i))
            if (state.length !== 1){
                return false
            }
        }
        this.onPressButton1()
        return true
    }


    async handleCheckChanges(id){
        var CheckBoxResults = []
        var answerState = this.state.CheckBox.filter((obj) => obj.id === id)[0].value
        if( answerState === true ) {
            this.state.CheckBox.forEach((answer) => {
                if (~~(answer.id/10) === ~~(id/10)){
                    CheckBoxResults = CheckBoxResults.concat({id: answer.id, value: false, score: answer.score})
                }
                else{
                    CheckBoxResults = CheckBoxResults.concat(answer)
                }
            })
        }
        else{
            this.state.CheckBox.forEach((answer) => {
                if (~~(answer.id/10) === ~~(id/10)){
                    if (answer.id === id){
                        CheckBoxResults = CheckBoxResults.concat({id: answer.id, value: true, score: answer.score})
                    }
                    else{
                        CheckBoxResults = CheckBoxResults.concat({id: answer.id, value: false, score: answer.score})
                    }
                }
                else{
                    CheckBoxResults = CheckBoxResults.concat(answer)
                }
            })
        }
        await this.setStateSync({
            CheckBox : CheckBoxResults
        })
        this.setStateSync({
            form_complete : this.isFormComplete()
        })

    }


    getCheckboxState(id){
        var state = this.state.CheckBox.filter((obj) => obj.id === id)
        return state[0].value
    }

    async onPressButton1(){
      const profil = this.getProfil()
      await this.setStateSync({
          Profil: profil,
          showForm: false
      })
      this.pushToDB()
      if(this.state.email.length > 0){
        getContactsList(this.state.email, this.state.phone, this.state.showEmail, profil, this.state.newsletter)
      }
      if(this.state.modifyingProfil){
        if(!this.state.firstConnection ){
            await this.setStateSync({
                mailAlreadySend:true,
                modifyingProfil:false,
                showForm:true
            })
        }
        else{
            await this.setStateSync({
                modifyingProfil:false,
                mailAlreadySend:false,

            })
        }
    }
    //   this.refreshDB()
    console.log(this.state)
    console.log(this.state.firstConnection , !this.state.modifyingAdress , !this.state.modifying ,!this.state.mailAlreadySend , !this.state.showForm , this.state.form_complete , this.state.Profil )
    }


    pushToDB(){
        var mail = ""
        if (this.state.firstname && this.state.lastname && this.state.phone && this.state.email && this.state.number && this.state.street && this.state.city && this.state.postcode && this.state.orderId && this.state.Profil ){
            mail = "<h3>Coucou la team !</h3><h4>Un client vient de mettre à jour le profil de son cadeau &#127881; &#127863;</h4><h2><b>Le profil de la commande <b>"
            + this.state.orderId.toString()+ '</b> est le <b>'+this.state.Profil.toString()
            + "</b></h2><p>Prénom: <b>"+this.state.firstname +"</b></p>"
            + "<p>Nom: <b>"+this.state.lastname+"</b></p>"
            + "<p>Téléphone: <b>"+this.state.phone+"</b></p>"
            + "<p>Mail:  <b>"+this.state.email+"</b></p>"
            + "<p>Adresse:  <b>"+this.state.number+ ", " +this.state.street + ", "
            + this.state.city+ ", " +this.state.postcode +"</b></p>"
            + "<h4>Des bisous &#128536;</h4>"
        }
        else if (this.state.orderId && this.state.Profil){
            mail = "<h3>Coucou la team !</h3><h4>Un client vient de mettre à jour le profil de son cadeau &#127881; &#127863;</h4><h2><b>Le profil de la commande <b>"
            + this.state.orderId.toString()+ '</b> est le <b>'+this.state.Profil.toString() + "</b></h2>"
        }
        else if (this.state.firstname && this.state.lastname && this.state.phone && this.state.email && this.state.number && this.state.street && this.state.city && this.state.postcode && this.state.orderId){
            mail = "<h3>Coucou la team !</h3><h4>Un client vient de mettre à jour l'adresse de livraison de son cadeau &#127881; &#127863;</h4><h2><b>Commande :<b>"
            + this.state.orderId.toString()+ "</h2><p>Prénom: <b>"+this.state.firstname +"</b></p>"
                    + "<p>Nom: <b>"+this.state.lastname+"</b></p>"
                    + "<p>Téléphone: <b>"+this.state.phone+"</b></p>"
                    + "<p>Mail:  <b>"+this.state.email+"</b></p>"
                    + "<p>Adresse:  <b>"+this.state.number+ ", " +this.state.street + ", "
                    + this.state.city+ ", " +this.state.postcode +"</b></p>"
        }
        else{
            window.location.href = 'https://trouvez-votre-profil.web.app/gift'; 
            return null;
        }
        firebase.firestore().collection('ordersTreated').add({
            id: this.state.orderId.toString(),
            date: new Date()
          })
        firebase.firestore().collection('mail').add({
            to: 'hello@vinidaily.com',
            message: {
              subject: "Commande - "+ this.state.orderId.toString() + " : Le Profil d'un cadeau a été mis à jour ",
              html: mail,
              orderId: this.state.orderId
            },
          })
    }

    getProfil(){
      var userScore = 0
      this.state.CheckBox.forEach((answer) => {
          if (answer.value === true){
              userScore += answer.score
          }
      })
      var profil = userScore <  3 ?  1 : (userScore <  6 ?  2 : 3)
      return profil

  }

  answerRendering(answer){
      return(
        <Row key={answer.id}>
          <label className="choice"> 
            <input
                className="option-input checkbox"
                type= 'checkbox'
                content="\f111"
                key={answer.id}
                title={answer.a_content}
                checked= {this.state.CheckBox.filter((obj) => obj.id === answer.id)[0].value}
                onChange = {()=>this.handleCheckChanges(answer.id)}/>
                {answer.a_content}
            </label>
        </Row>
      )
  }
  getLogo(prof){
      if(prof.logo === "vigne"){
        return vigne
      }
      else if(prof.logo === "grappe"){
        return grappe
      }
      else if(prof.logo === "barrique"){
        return barrique
      }

  }
  getTimeStatus = (timeStatusOk) => {
      console.log(this.state.timeStatusOk)
      this.setState({
          timeStatusOk: timeStatusOk
      })
  }

  handleChange(e){
      console.log(e.target.id)
    this.setState({
        [e.target.id] : e.target.value
    })
  }

  handleCheckNews(e){
    this.setState({
        newsletter: e.target.checked
    })
  }
  handleCheckPC(e){
    this.setState({
        pcAgreement: e.target.checked
    })
  }

  submit(e){
    e.preventDefault();
    console.log(e)
    console.log(this.state)
    this.setState({
        rgpdOk: this.state.pcAgreement
    })
    if(this.state.modifyingAdress){
        if(!this.state.firstConnection ){
            this.setState({
                modifyingAdress:false,
                mailAlreadySend: true,
                showForm:true,
                showEmail:false
                })
        }
        else{
            this.setState({
                modifyingAdress:false,
                showEmail:false
                })
        }
    }
    this.pushToDB()
    createContact(this.state.email, this.state.phone, this.state.newsletter)
    
  }

  renderForm(){
    return (
            <Form onSubmit={(e)=>this.submit(e)} >
                <h4 className="card-title" style={{color:"#147880",textAlign:"center", fontSize: "1.2rem", fontWeight:700}}>Vos informations de livraison</h4>
                <p  style={{opacity: "0.7", color:"#147880",textAlign:"center", fontSize: "0.8rem", fontWeight:500}}>Attention ! Nous ne livrons qu'en France métopolitaine</p>
                <Row style={{display:"flex"}}>
                    <Col md={6}>
                        <Form.Group className="input-form" controlId="firstname">
                        <Row>
                                <Form.Label style={{ fontWeight:600}}>Prénom</Form.Label>
                            </Row>
                            <Row>
                                <Form.Control
                                    required
                                    className="inputr"
                                    style={{border: "None", borderBottom: "1px solid #d2d2dc", marginLeft: "10px"}}
                                    type="text" 
                                    value={this.state.firstname}
                                    placeholder="Éric" 
                                    onChange={e => this.handleChange(e)}/>
                                
                                </Row>
                        </Form.Group>
                    </Col>
                    <Col  md={6}>
                        <Form.Group className="input-form" controlId="lastname">
                        <Row>
                                <Form.Label style={{ fontWeight:600}}>Nom</Form.Label>
                            </Row>
                            <Row>
                                <Form.Control
                                    required
                                    className="inputr"
                                    style={{border: "None", borderBottom: "1px solid #d2d2dc", marginLeft: "10px"}}
                                    type="text" 
                                    value={this.state.lastname}
                                    placeholder="Dupont" 
                                    onChange={e => this.handleChange(e)}/>
                                
                                </Row>
                        </Form.Group>
                    </Col>
                </Row >
                
                <Row style={{display:"flex"}}>
                    <Col md={6}>
                        <Form.Group className="input-form" controlId="email">
                        <Row>
                                <Form.Label style={{ fontWeight:600}}>Adresse mail</Form.Label>
                            </Row>
                            <Row>
                                <Form.Control
                                    required
                                    className="inputr"
                                    style={{border: "None", borderBottom: "1px solid #d2d2dc", marginLeft: "10px"}}
                                    type="email" 
                                    value={this.state.email}
                                    placeholder="hello@vinidaily.com" 
                                    onChange={e => this.handleChange(e)}/>
                                
                                </Row>
                        </Form.Group>
                    </Col>
                    <Col  md={6}>
                        <Form.Group className="input-form" controlId="phone">
                        <Row>
                                <Form.Label style={{ fontWeight:600}}>Téléphone</Form.Label>
                            </Row>
                            <Row>
                                <Form.Control
                                    required
                                    className="inputr"
                                    style={{border: "None", borderBottom: "1px solid #d2d2dc", marginLeft: "10px"}}
                                    type="phone" 
                                    value={this.state.phone}
                                    placeholder="0612345678" 
                                    onChange={e => this.handleChange(e)}/>
                                
                                </Row>
                        </Form.Group>
                    </Col>
                </Row >
                
                <Row style={{display:"flex"}}>
                    <Col  md={6}>
                        <Form.Group className="input-form" controlId="number">
                            
                            <Row>
                                <Form.Label style={{ fontWeight:600}}>&#8470;</Form.Label>
                            </Row>
                            <Row>
                                <Form.Control
                                    required
                                    className="inputr"
                                    style={{border: "None", borderBottom: "1px solid #d2d2dc", marginLeft: "10px"}}
                                    type="number" 
                                    value={this.state.number}
                                    placeholder="15" 
                                    onChange={e => this.handleChange(e)}/>
                                
                                </Row>
                            </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="input-form" controlId="street">
                        <Row>
                                <Form.Label style={{ fontWeight:600}}>Voie</Form.Label>
                            </Row>
                            <Row>
                                <Form.Control
                                    required
                                    className="inputr"
                                    style={{border: "None", borderBottom: "1px solid #d2d2dc", marginLeft: "10px"}}
                                    type="text" 
                                    value={this.state.street}
                                    placeholder="Rue Saint-Julien" 
                                    onChange={e => this.handleChange(e)}/>
                                
                                </Row>
                        </Form.Group>
                    </Col>
                </Row>

                <Row style={{display:"flex"}}>
                    <Col md={6}>
                        <Form.Group className="input-form" controlId="city">
                            <Row>
                                <Form.Label style={{ fontWeight:600}}>Ville</Form.Label>
                            </Row>
                            <Row>
                                <Form.Control
                                    required
                                    className="inputr"
                                    style={{border: "None", borderBottom: "1px solid #d2d2dc", marginLeft: "10px"}}
                                    type="text" 
                                    value={this.state.city}
                                    placeholder="Palaiseau" 
                                    onChange={e => this.handleChange(e)}/>
                                
                                </Row>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="input-form" controlId="postcode">
                            <Row>
                                <Form.Label style={{ fontWeight:600}}>Code Postal</Form.Label>
                            </Row>
                            <Row>
                                <Form.Control
                                    required
                                    className="inputr"
                                    style={{border: "None", borderBottom: "1px solid #d2d2dc", marginLeft: "10px"}}
                                    type="number" 
                                    value={this.state.postcode}
                                    placeholder="91120" 
                                    onChange={e => this.handleChange(e)}/>
                                
                             </Row>
                        </Form.Group>
                    </Col>
                </Row>
                <Form.Group className="check-input" controlId="formBasicPassword" style={{display:"flex",marginTop:35}}>
                        <Form.Check
                            required
                            className="inputr"
                            onChange={e => this.handleCheckPC(e)}/>
                            <Form.Label style={{ marginLeft:"25px"}}>J'accepte la <a href="https://www.vinidaily.com/politique-de-confidentialit%C3%A9"> politique de confidentialité </a>   </Form.Label>
                </Form.Group>

                <Form.Group className="check-input" controlId="formBasicPassword" style={{display:"flex",  marginTop:10}}>
                    <Form.Check
                        className="inputr"
                        onChange={e => this.handleCheckNews(e)}/>
                    <Form.Label style={{ marginLeft:"25px"}}> J'accepte de recevoir la newsletter de Vinidaily </Form.Label>
                </Form.Group>
                <Form.Group style={{display : "flex"}}>
                    <Button
                        className="submit"
                        type="submit">
                        Personnaliser mon cadeau</Button>
                </Form.Group>
            </Form>
    )
  }

  render() {
      return (
        <Container>
            <Container className="container1">
                <Container className="container2">
                <Row className="logo">
                        <img alt="Vinidaily" src={logo}/>
                </Row>

                {/* {!this.state.order && (<IdentifyCommand/>)} */}

                { !this.state.mailAlreadySend && this.state.showEmail && !this.state.rgpdOk&& (
                    <>

                    <h1 style={{marginTop:50, color:"#e5c617", fontWeight:600, textAlign:"center"}}>Vous avez reçu un cadeau Vinidaily <span style={{marginTop:50, color:"#e5c617", fontWeight:100, textAlign:"center"}}>&#127881; &#127863;</span></h1>
                    
                    <Row style={{opacity:1, textAlign:"center"}}>
                    <Col md={6} style={{ padding:"0 20% 0 20%",marginTop:50, marginBottom:50, color:"#ef8277"}}>
                        <h4 style={{ fontWeight: 400}}>Nous allons concevoir votre coffret personnalisé !</h4>
                        <h4 style={{ fontWeight: 400}}>Pour cela répondez à quelques questions pour que nous puissions identifier votre profil gustatif</h4>
                    </Col>
                    </Row>
                    <Container className="container1">
                        <Container className="container2">
                            <Row style={{marginTop:-30}} className="d-flex justify-content-center mt-100">
                                <Col className="card" >
                                    <div  className="card-body" >
                                        <div> 
                                            {this.renderForm()}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Container>
                    </>
                )}
                {!this.state.mailAlreadySend && this.state.showForm && (this.state.rgpdOk || !this.state.showEmail) && (
                    this.state.questionsAll.map((question) => (
                    <Row key={question.id} className="d-flex justify-content-center mt-100">
                        <Col className="card" >
                            <div  className="card-body" >
                            <div> 
                            <h4 className="card-title" >{question.q_content}</h4>
                                {question.answers.map(
                                    (answer) => (this.answerRendering(answer))
                                )}
                            </div>
                            </div>
                        </Col>
                    </Row>
                )))}
                </Container>
            </Container>
            { !this.state.firstConnection && !this.state.modifying && this.state.mailAlreadySend &&
            (
            <Container className="container3">
                <Container className="container2">
                    <Row className="profil">
                                <Row className="d-flex justify-content-center ">
                                    <Col className="card-profile" >
                                        <div  className="card-body" >
                                            <div style={{textAlign:"center"}}> 
                                                <h1 style={{color:"#ef8277", fontWeight: "400"}}>Votre cadeau est en route</h1>
                                                <img style={{width:"30%", display:"inline-block"}} alt="Mon Profil" src={gif} />
                                                {this.state.timeStatusOk && (
                                                <Row>
                                                    <Button
                                                        style={{display:"inline-block"}}
                                                        className="modif-button"
                                                        onClick={()=> {this.setState({modifying:true})}}>
                                                        Modifier mes préférences
                                                    </Button>
                                                    {this.state.pushTime && (<TimeLeft parentCallback ={this.getTimeStatus} date={this.state.pushTime} />)}
                                                </Row>)}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                    </Row>
                </Container>
            </Container>
            )}

            {this.state.modifying &&
                        (
                        <Container className="container3">
                            <Container className="container2">
                                <Row className="profil">
                                    <Row className="d-flex justify-content-center ">
                                        <Col className="card-profile" >
                                            <div  className="card-body" >
                                                <h4 className="card-title" style={{color:"#ef8277",textAlign:"center", fontSize: "1.2rem", fontWeight:700}}>Que voulez-vous modifier ?</h4>
                                
                                                <Row className="modif-button3" onClick={() => {this.setState({modifying:false, mailAlreadySend: false, showEmail:true, showForm: false, modifyingAdress: true, rgpdOk: false})}}>
                                                    <h3 style={{fontSize:"0.8rem", fontWeight: 500}}>Mes infos de livraison</h3>
                                                </Row>
                                                <Row  className="modif-button3" onClick={() => {this.setState({modifying:false, mailAlreadySend: false, showEmail:false, showForm: true, modifyingProfil: true})}}>
                                                    <h3 style={{fontSize:"0.8rem", fontWeight: 500}}>Mon profil gustatif</h3>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </Row>
                            </Container>
                        </Container>
                        )}

            {this.state.firstConnection && !this.state.modifyingAdress && !this.state.modifying &&!this.state.mailAlreadySend && !this.state.showForm && this.state.form_complete && this.state.Profil && 
            (<>
            <Container className="container3">
                <Container className="container2">
                    <Row className="profil">
                        <Row className="d-flex justify-content-center ">
                            <Col className="card-profile" >
                                <div  className="card-body" >
                                    <div style={{textAlign:"center"}}> 
                                        <h1 style={{color:"#ef8277", fontWeight: "400"}}>C'est parti ! Nous vous préparons nos meilleurs vins</h1>
                                        <img style={{width:"30%", display:"inline-block"}} alt="Mon Profil" src={gif} />
                                            {this.state.timeStatusOk && (
                                            <Row>
                                                <Button
                                                    style={{display:"inline-block"}}
                                                    className="modif-button2"
                                                    onClick={()=> {this.setState({modifying:true})}}>
                                                    Modifier mes préférences
                                                </Button>
                                                {<TimeLeft parentCallback={this.getTimeStatus} date={this.state.pushTime} />}
                                            </Row>)}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                        </Row>
                    </Row>
                </Container>
            </Container>
            
            <Container className="container4">
                <Container className="container2">
                    <Row className="button-profile-container">
                        <a href={profiles_desc.find(item => item.profile === this.state.Profil).url} style={{textDecoration:"none"}}>
                            <div className="button-profile-shop" >
                                <p>Retrouvez notre sélection de vins adaptés à votre profil &#8680;</p>
                            </div>
                        </a>
                    </Row>
                </Container>
            </Container>
            </>)
        }
        </Container>
      )
  }
}

export default withRouter(GiftQuestionProfile)